<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <c-form-item type="input" label="活动名称" name="activity_name"></c-form-item>
                    <c-form-item type="checkbox" name="start_state" :options="activityState"></c-form-item>
                </c-form>
            </m-search>

            <m-operate>
                <c-button power="b_activity_bargain_edit" color="sys" @click="navigateTo('/activity_bargain_add')">新建活动</c-button>
                <c-button power="b_activity_bargain_edit" color="sys" @click="otherConfig()">砍价专区配置</c-button>
            </m-operate>

            <c-table ref="table">

                <c-table-column
                        label="活动状态"
                        name="start_state"
                        width="80"
                >
                    <template v-slot="{data}">
                        <span v-if="data.start_state == 0" style="color:#999">{{activityStateText[data.start_state]}}</span>
                        <span v-if="data.start_state == 1" style="color:dodgerblue">{{activityStateText[data.start_state]}}</span>
                        <span v-if="data.start_state == 2" style="color:#999">{{activityStateText[data.start_state]}}</span>
                        <span v-if="data.start_state == 3" style="color:red">{{activityStateText[data.start_state]}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="活动名称"
                        name="activity_name"
                        width="200"
                ></c-table-column>

                <c-table-column
                        label="发起人数"
                        name="launch_count"
                        width="80"
                ></c-table-column>

                <c-table-column
                        label="帮砍人次"
                        name="bargain_count"
                        width="80"
                ></c-table-column>

                <c-table-column
                        label="支付订单数"
                        name="order_count"
                        width="100"
                ></c-table-column>

                <c-table-column
                        label="砍至底价人数"
                        name="bargain_success_count"
                        width="110"
                ></c-table-column>

                <c-table-column
                        label="底价成交订单"
                        name="min_price_order_count"
                        width="110"
                ></c-table-column>

                <c-table-column
                        label="活动时间"
                        width="280"
                >
                    <template v-slot="{data}">{{data.begin_date}} - {{data.end_date}}</template>
                </c-table-column>

                <c-table-column
                        label="创建时间"
                        name="create_date"
                        width="140"
                >
                </c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="160"
                >
                    <template v-slot="row">
                        <c-table-button power="b_activity_bargain_view" @click="navigateTo(`/activity_bargain_detail/${row.data.id}`)">查看</c-table-button>
                        <c-table-button v-if="row.data.start_state != 1 && row.data.start_state != 2" power="b_activity_bargain_view" @click="navigateTo(`/activity_bargain_edit/${row.data.id}`)">修改</c-table-button>
                        <c-table-button power="b_activity_bargain_state" v-if="row.data.state == 2 && row.data.start_state != 2" @click="disableActivity(row,1)">暂停</c-table-button>
                        <c-table-button power="b_activity_bargain_state" v-if="row.data.state == 1 && row.data.start_state != 2" @click="disableActivity(row,2)">开始</c-table-button>
                        <c-table-button v-if="row.data.start_state == 0 || row.data.start_state == 2" power="b_activity_bargain_edit" @click="deleteActivity(row)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </module>

        <c-dialog ref="editDialog" title="砍价专区配置" width="600" @resolve="submitForm">
            <c-form ref="editForm">
                <c-form-item type="image" label="专区图片" name="BARGAIN_ACTIVITY_BANNER"></c-form-item>
                <c-form-item type="textarea" label="介绍信息" name="BARGAIN_ACTIVITY_REMARK" ></c-form-item>
            </c-form>
        </c-dialog>

    </page>
</template>

<script>
    export default {
        name: 'm_activity_bargain',

        data() {
            return {
                activityState: [{
                    name: '未开始',
                    value: 0
                }, {
                    name: '进行中',
                    value: 1
                }, {
                    name: '暂停中',
                    value: 3
                }, {
                    name: '已结束',
                    value: 2
                }
                ]
            }
        },

        computed: {
            activityStateText() {
                var state = {};
                this.activityState.forEach(item => {
                    state[item.value] = item.name;
                });

                return state;
            }
        },

        mounted() {
            this.$refs.search.search();
            this.$bus.$on('activityBargainList.update', () => {
                this.$refs.search.search();
            });
        },

        methods: {
            searchHandle(data) {
                this.$refs.table.load({
                    url: '/activityBargain/list',
                    data
                });
            },

            disableActivity(item,state) {
                this.$confirm({
                    text: state == 2 ? '确定要开始此砍价活动吗？' : '确定要暂停此砍价活动吗',
                    resolve: () => {
                        this.request({
                            url: '/activityBargain/updateActivityState',
                            data: {
                                id: item.data.id,
                                state: state
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    text: state == 2 ? '开始成功' :'暂停成功'
                                });
                                this.$refs.table.update();
                            },
                            fail: (code, data, msg) => {
                                this.$confirm({
                                    text: msg,  // 提示内容,
                                    buttonName: '知道了',  // 确定按钮文字
                                    cancelButton: false  // 是否显示取消按钮
                                });
                                return false;
                            }
                        });
                    }
                });
            },

            deleteActivity(item) {
                this.$confirm({
                    text: '确定要删除此砍价活动吗？',
                    resolve: () => {
                        this.request({
                            url: '/activityBargain/delete',
                            data: {
                                id: item.data.id
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    text: '删除成功'
                                });
                                this.$refs.table.update();
                            }
                        });
                    }
                });
            },

            copyActivity(item) {
                this.request({
                    url: '/activityBargain/copy',
                    data: {
                        id: item.data.id
                    },
                    loading: true,
                    success: () => {
                        this.$message({
                            text: '复制成功'
                        });
                        this.$refs.table.update();
                    }
                });
            },
            otherConfig(){
                this.request({
                    url: '/activityBargain/config',
                    loading: true,
                    success: (data) => {
                        this.$refs.editForm.clear();
                        this.$refs.editForm.set({"BARGAIN_ACTIVITY_BANNER":data.BARGAIN_ACTIVITY_BANNER,"BARGAIN_ACTIVITY_REMARK":data.BARGAIN_ACTIVITY_REMARK});
                        this.$refs.editDialog.open();
                    }
                });

            },
            submitForm(stop) {
                stop();
                let submitUrl = '/activityBargain/updateConfig';
                this.$refs.editForm.submit({
                    url: submitUrl,
                    rule: {
                        BARGAIN_ACTIVITY_BANNER: [{
                            type: 'empty',
                            word: '请上传专区图片'
                        }]
                    },
                    dataFormatter: data => {
                        let configs = [];
                        let banner={},remarks={};
                        banner.id="11";
                        banner.config_item_value= data.BARGAIN_ACTIVITY_BANNER;
                        remarks.id="12";
                        remarks.config_item_value= data.BARGAIN_ACTIVITY_REMARK;
                        configs.push(banner,remarks);
                        data.platform_config_list = configs;
                        return data;
                    },
                    success:(data,res) => {
                        this.$message({
                            text: '操作成功',
                            icon: 'success'
                        });
                        this.$refs.table.update();
                        this.$refs.editDialog.close();
                    },
                });
            }
        }
    }
</script>